module.exports = __webpack_public_path__ + "img/ico_jcxxcj.02b81eb3.png";